import ScrollMagic from 'scrollmagic'

export default (function() {

  function init(scrollController) {

    if (!document.body.classList.contains('home-landing')) {
      return;
    }

    // Hero section tagline block
    const heroContainer = document.querySelector('.hero')
    const heroTaglineHr = heroContainer.querySelector('.u-block')

    const calloutContainers = Array.from(document.querySelectorAll('.callout'))
    const calloutLblContainers = calloutContainers.map((calloutBlock) => calloutBlock.querySelectorAll('.c-lbl-container'))

    calloutContainers.forEach((calloutContainer, i) => {
      calloutLblContainers.forEach((lblContainer, c) => {

        let scene = new ScrollMagic.Scene({
          triggerElement: lblContainer,
          offset: 100,
          triggerHook: 'onEnter'
        })
        .setClassToggle(lblContainer, 'reveal')
        .on('enter', function() {
          calloutContainers[i].querySelector('.u-block').classList.add('u-animation-hr-slide-down')
          calloutContainers[i].querySelector('.u-block').classList.add('u-animation-hr-slide-down--no-delay')
        })
        .reverse(false)
        .addTo(scrollController);

      })
    })
  }

  return {
    init
  }

})();
